import {Button, Icons, Skeleton} from '@continuum/ui';
import {pageCardVariants} from './page-row';

const MESSAGE_CLASS =
  'flex h-full flex-col items-center justify-center gap-3 px-6 py-10 text-center text-sm text-muted-foreground';

export const PagesListSkeleton = ({count}: {count: number}) => (
  <ul aria-hidden className="space-y-2">
    {Array.from({length: count}, (_, row) => (
      <li key={row} className={pageCardVariants({state: 'skeleton'})}>
        <div className="min-w-0 flex-1 space-y-2.5">
          <Skeleton className="h-4 w-4/5" />
          <Skeleton className="h-3.5 w-1/3" />
        </div>
        <Skeleton className="size-5 shrink-0 rounded-full" />
      </li>
    ))}
  </ul>
);

export const PagesListError = ({onRetry}: {onRetry: () => void}) => (
  <div className={MESSAGE_CLASS}>
    <p>Your pages could not be loaded.</p>
    <Button variant="outline" size="sm" onClick={onRetry}>
      Try again
    </Button>
  </div>
);

export const PagesListEmpty = () => (
  <div className={MESSAGE_CLASS}>
    <span className="flex size-10 items-center justify-center rounded-full bg-muted">
      <Icons.fileText className="size-5" />
    </span>
    <div className="space-y-1">
      <p className="text-foreground">No pages have been shared with you yet.</p>
      <p className="text-xs">
        When your advisor shares a page with you, it will appear here.
      </p>
    </div>
  </div>
);

// Auto-loading is the only path to the next page, so a failure needs its own
// way back or the list silently stops growing.
export const PagesListLoadMoreError = ({onRetry}: {onRetry: () => void}) => (
  <div className="flex flex-col items-center gap-2 px-1 py-4 text-center">
    <p className="text-xs text-muted-foreground">
      More pages could not be loaded.
    </p>
    <Button variant="outline" size="sm" onClick={onRetry}>
      Try again
    </Button>
  </div>
);
